import Rollbar from 'rollbar';
import { merge } from 'lodash';

const RollbarToken = process.env.VUE_APP_ROLLBAR_TOKEN || process.env.ROLLBAR_TOKEN;

const defaults = {
  enabled: !!RollbarToken,
  accessToken: RollbarToken || '',
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubFields: ['Authorization'],
  client: {
    javascript: {
      source_map_enabled: true,
      guess_uncaught_frames: true,
    },
  },
  autoInstrument: true,
  includeItemsInTelemetry: true,
  scrubTelemetryInputs: true,
};

class RollbarWrapper {
  constructor() {
    this.person = {};
    this.environment = process.env.NODE_ENV;
    this.configOverrides = {};
    this.instance = new Rollbar(this.config);
  }

  get config() {
    return merge({}, defaults, this.configOverrides, {
      payload: {
        person: this.person,
        environment: this.environment,
      },
    });
  }

  updatePerson(value) {
    this.person = value;
    this.instance.configure(this.config);
  }

  updateConfig(config) {
    this.configOverrides = config;
    this.instance.configure(this.config);
  }

  /* eslint-disable no-multi-spaces */
  critical(...params) { this.instance.critical(...params); }
  error(...params)    { this.instance.error(...params); }
  warning(...params)  { this.instance.warning(...params); }
  info(...params)     { this.instance.info(...params); }
  /* eslint-enable no-multi-spaces */

  install(Vue) {
    /* eslint-disable no-param-reassign */
    Vue.prototype.$rollbar = this;
  }
}

export default new RollbarWrapper();
